import {
  MonthGrid,
  Header,
  Dashboard,
} from '@app/components/Calendars/components';
import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import type { NCalendars } from '@app/components/Calendars/types';

import '@app/components/Calendars/components/CalendarView/styles/CalendarView.desktop.scss';

export const CalendarView: NCalendars.CalendarViewType = ({
  dayHumbers,
  toPrevDate,
  toNextDate,
  type,
  tasks = [],
  createTaskForRange,
  openPreviewTaskModal,
  isLoading,
  className = '',
}) => {
  return (
    <div
      className={`${CV_PREFIX}-container task-list-calendar-container ${className}`}
    >
      <Header
        dayHumbers={dayHumbers}
        toPrevDate={toPrevDate}
        toNextDate={toNextDate}
        smallButtons={type === 'monthly'}
      />

      {type === 'monthly' ? (
        <MonthGrid isLoading={isLoading} />
      ) : (
        <Dashboard
          columns={tasks as Array<NCalendars.DailyTasks>}
          createTaskForRange={createTaskForRange}
          openPreviewTaskModal={openPreviewTaskModal}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};
